export default __webpack_public_path__ + "static/media/DENTISTCERTIFICATEA5_EN.c8933017.png";